export const ExpiredContactsModal: string = 'ExpiredContactsModal';
